import React from "react";
import { Link } from "react-router-dom";
import { Progress, Tooltip } from "antd";
import { getProjectProgress } from "pages/projects/project-utils";
import styles from "./table.module.css";

export const getProjectLink = (project, companyId, userAccessLevels) => {
  const projectId = project["Project ID"];
  const basePath = `/main/company/${companyId}/projects/${projectId}`;
  const permissions = userAccessLevels?.projectAccessLevel?.[projectId];
  const pageOrder = [
    { key: "Dashboard", path: `${basePath}/dashboard` },
    { key: "Procurement Log", path: basePath },
    { key: "Admin", path: `/main/company/${companyId}/create-project/${projectId}` },
    { key: "Directory", path: `${basePath}/directory` },
    { key: "Reports", path: `${basePath}/canned-reports` },
  ];
  return pageOrder.find(({ key }) => parseInt(permissions?.[key] || "0", 10) > 0)?.path ?? `${basePath}/dashboard`;
};

export const ProjectIdentity = ({ project, href }) => (
  <Link to={href} className={styles.projectIdentity}>
    <span className={styles.projectName}>{project["Project Name"] || "Untitled project"}</span>
    <span className={styles.projectNumber}>Project #{project["Project Number"] ?? "—"}</span>
  </Link>
);

export const ProjectProgress = ({ value }) => {
  const progress = getProjectProgress(value);
  if (progress === null) return <span className={styles.secondary}>—</span>;
  return (
    <div className={styles.progress} aria-label={`${progress.toFixed(2)}% completed`}>
      <span className={styles.progressValue}>{progress.toFixed(2)}%</span>
      <Progress percent={progress} showInfo={false} size="small" strokeColor={progress === 100 ? "#52a47b" : "#1695b5"} />
    </div>
  );
};

const ALERTS = [
  { field: "DraftEntries", type: "draft", label: "Draft", description: "Items with no submittal issued" },
  { field: "ApproachingDealineEntries", type: "pending", label: "Pending", description: "Items due within the next 14 days" },
  { field: "OverdueEntries", type: "overdue", label: "Overdue", description: "Items that are due today or earlier" },
  { field: "CompletedEntries", type: "completed", label: "Completed", description: "Items with an actual delivery day" },
];

export const ProjectAlerts = ({ project }) => (
  <div className={styles.alerts}>
    {ALERTS.map(({ field, type, label, description }) => (
      <Tooltip key={field} title={description}>
        <span className={`${styles.alert} ${styles[type]}`} aria-label={`${project[field] ?? 0} ${label.toLowerCase()} items`}>
          <strong>{project[field] ?? 0}</strong> {label}
        </span>
      </Tooltip>
    ))}
  </div>
);
